import React from 'react';
import LandingHeader from '../components/landing-page/LandingHeader';
import Hero from '../components/landing-page/Hero';
import Features from '../components/landing-page/Features';
import FAQ from '../components/landing-page/FAQ';
import Footer from '../components/landing-page/Footer';
import PricingTable from '../components/landing-page/PricingTable';
import { features, faqs, footerNavigation } from '../components/landing-page/contentSections';
import OurPricingTable from '../components/landing-page/ourPricingTable2';

export default function LandingPage() {
  return (
    <div className='bg-white dark:text-white dark:bg-boxdark-2'>
      <LandingHeader />
      <main className='isolate dark:bg-boxdark-2'>
        <Hero />
        <section id='current-product'>
          <OurPricingTable />
        </section>
        {/* <PricingTable /> */}
        <Features features={features} />
        <FAQ faqs={faqs} />
      </main>
      <Footer footerNavigation={footerNavigation} />
    </div>
  );
}
